export default __webpack_public_path__ + "static/media/barberlogo.98f5523f.png";